module.exports = __webpack_public_path__ + "img/flutterwave.07611d92.png";